import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Box from '@mui/material/Box';

import Typography from '@ts-core/components/Typography';
import Button from '@ts-core/components/Button';

import ThreadListItem from './ThreadListItem';
import ThreadsEmptyView from './ThreadsEmptyView';

const ThreadsList = (props) => {
  const { loading, threads: pThreads, onCreatePost } = props;

  const threads = loading ? Array.from(new Array(3)) : pThreads;

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      maxWidth={{ md: '100%', lg: 800 }}
      margin="auto"
    >
      <Box
        width="100%"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        px={{ xs: 1, md: 0 }}
        my={1}
      >
        <Typography variant="h4">
          <FormattedMessage id="forum.title" defaultMessage="Foro" />
        </Typography>
        <Box minWidth={8} />
        <Box>
          <Button color="primary" variant="contained" onClick={onCreatePost}>
            <FormattedMessage
              id="forum.createNewPost"
              defaultMessage="Crear Post"
            />
          </Button>
        </Box>
      </Box>
      <Box width="100%" mt={{ xs: 2, md: 3 }}>
        {threads.map((thread, index) => (
          <ThreadListItem key={index} thread={thread} loading={loading} />
        ))}
      </Box>
      {!loading && threads?.length === 0 && <ThreadsEmptyView />}
    </Box>
  );
};

ThreadsList.propTypes = {
  loading: PropTypes.bool.isRequired,
  threads: PropTypes.array,

  onCreatePost: PropTypes.func,
};

ThreadsList.defaultProps = {
  threads: [],

  onCreatePost() {},
};

export default ThreadsList;
